export const COARSE_FEEDBACK_PROPS = {
  coarseFeedback: {
    type: Boolean,
    required: false,
    default: undefined,
  },
} as const
